import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=65e4bcbd"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65e4bcbd')) {
      api.createRecord('65e4bcbd', component.options)
    } else {
      api.reload('65e4bcbd', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=65e4bcbd", function () {
      api.rerender('65e4bcbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/retenciones/Index.vue"
export default component.exports